// src/js/api.js

export async function fetchProducts() {
  const response = await fetch("https://api.keshavkingdom.com/public/substitute");

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  return await response.json();
}

export async function submitUserDetails(formData) {
  const response = await fetch('https://api.keshavkingdom.com/public/order', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  });

  return response;
}
